import React from 'react';
import { Alert, AlertTitle } from '@mui/material';

interface ToolNoticeProps {
  /** Unique key for localStorage dismissal (e.g., "cafe", "risk") */
  toolKey: string;
  /** The notice message to display */
  message: string;
  /** Optional title (defaults to "Note") */
  title?: string;
  /** MUI Alert severity (defaults to "info") */
  severity?: 'info' | 'warning' | 'success' | 'error';
}

const storageKey = (toolKey: string) => `helpdesk-notice-${toolKey}-dismissed`;

const ToolNotice: React.FC<ToolNoticeProps> = ({ toolKey, message, title = 'Note', severity = 'info' }) => {
  const [dismissed, setDismissed] = React.useState(() => {
    try {
      return localStorage.getItem(storageKey(toolKey)) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(storageKey(toolKey), '1');
    } catch { /* localStorage unavailable */ }
  };

  return (
    <Alert severity={severity} onClose={handleDismiss} sx={{ mb: 2 }}>
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
  );
};

export default ToolNotice;
